import { Fragment, useRef } from "react";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import InvoiceDateSection from "./InvoiceDateSection";
import InvoiceHead from "./InvoiceHead";
import InvoiceTable from "./InvoiceTableHead";
import InvoiceTaxSection from "./InvoiceTaxSection";

const InvoiceFourContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  return (
    <Fragment>
      <Container className="invoice-2">
        <Row>
          <Col sm="12">
            <div ref={contentRef}>
              <Card>
                <CardBody>
                  <Table borderless>
                    <tbody>
                      <InvoiceHead />
                      <InvoiceDateSection />
                      <InvoiceTable />
                      <tr>
                        <td style={{ height: 3, width: "100%", background: "linear-gradient(90deg, #2A5699 20.61%, rgba(111, 90, 153, 0) 103.6%)", display: "block", padding: "0px" }} />
                      </tr>
                      <InvoiceTaxSection />
                      <tr style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <td className="p-0">
                          <Image src={dynamicImage(`email-template/invoice-3/sign.png`)} alt="sign" />
                          <span style={{ display: "block", fontSize: 18, fontWeight: 600 }}>Laurine T. Ebbert</span>
                          <span style={{ display: "block", fontSize: 14, paddingTop: 5 }}>( Designer )</span>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
      <InvoiceButtons contentRef={contentRef} />
    </Fragment>
  );
};

export default InvoiceFourContainer;
